import { RecoilRoot } from 'recoil';
import { ChainlitAPI, ChainlitContext } from '@chainlit/react-client';
import { ReactNode } from 'react';

interface IProps {
  children: ReactNode
}

const CHAINLIT_SERVER_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/';

const apiClient = new ChainlitAPI(CHAINLIT_SERVER_URL, 'webapp');

export const ChainlitProvider = ({ children }: IProps) => {
  return (
    <ChainlitContext.Provider value={apiClient}>
      <RecoilRoot>
        {children}
      </RecoilRoot>
    </ChainlitContext.Provider>

  );
  
};
